import { Listing } from "@t/Listing"
import css from "@css/modules/BidSuggestion.module.scss"
import { StartRating } from "@components/StartRating"
import React, { useState } from "react"
import { GradientBar } from "./GradientBar"
import useSWR from "swr"
import { OfferForecastRes } from "@t/OfferForecast"
import { Spin } from "antd"
import { useListingDealScore, useSoldListings } from "@utils/hooks/useListingDealScore"

export function SuggestionSide({ listing }: { listing: Listing }) {
    const img = listing?.resort?.logo?.formats?.thumbnail || listing?.resort?.logo?.formats?.medium
    const [price, setPrice] = useState(0)
    const { data, isLoading } = useSWR<OfferForecastRes>(`offer-forecast?id=${listing.id}`, {
        refreshInterval: 0,
        keepPreviousData: true,
        revalidateOnMount: true,
        revalidateOnFocus: false
    })
    const { meta } = useListingDealScore(listing)
    const { totalForLastMonth } = useSoldListings(listing)
    return (
        <div className={css.suggestionSide}>
            <h2>
                Bid Suggestion Tool <span className={css.beta}>Beta!</span>
            </h2>
            <div className={css.suggestionContent}>
                <div className={css.interactiveContent}>
                    {isLoading ? (
                        <div className={css.loadingWrap}>
                            <Spin size="large" />
                        </div>
                    ) : (
                        <GradientBar listing={listing} setPrice={setPrice} data={data?.data} />
                    )}
                    <div className={css.ratingGroups}>
                        <div className={css.ratingSlot}>
                            <div className={css.slotContent}>
                                <span>
                                    Poor <span className={css.dealText}>Deal</span>
                                </span>
                                <StartRating size={0} rating={2} gap={0} className={css.stars} />
                            </div>
                        </div>
                        <div className={css.ratingSlotSpace} />
                        <div className={css.ratingSlot}>
                            <div className={css.slotContent}>
                                <span>
                                    Average <span className={css.dealText}>Deal</span>
                                </span>
                                <StartRating size={0} rating={3} gap={0} className={css.stars} />
                            </div>
                        </div>
                        <div className={css.ratingSlotSpace} />
                        <div className={css.ratingSlot}>
                            <div className={css.slotContent}>
                                <span>
                                    Great <span className={css.dealText}>Deal</span>
                                </span>
                                <StartRating size={0} rating={4} gap={0} className={css.stars} />
                            </div>
                        </div>
                        <div className={css.ratingSlotSpace} />
                        <div className={css.ratingSlot}>
                            <div className={css.slotContent}>
                                <span>
                                    Exceptional <span className={css.dealText}>Deal</span>
                                </span>
                                <StartRating size={0} rating={5} gap={0} className={css.stars} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={css.suggestionInfo}>
                    <div className={css.infoContent}>
                        <h3>Suggested Offer: ${price} Per Point</h3>
                        <div className={css.infoText}>
                            <div className={css.textBlocks}>
                                <p>
                                    <img src="/images/BidSuggestion/Small%20Business.png" alt="suggestion icon" />
                                    The DealScore ranges are calculated using data from {meta?.pagination?.total} similar listings currently on the market and {totalForLastMonth}{" "}
                                    recently sold listings.
                                </p>
                                <p>
                                    <img src="/images/BidSuggestion/About.png" alt="suggestion icon" />
                                    Most brokers will advise sellers to reject offers that are wildly below asking price.
                                </p>
                                <p>
                                    <img src="/images/BidSuggestion/Lowest%20Price.png" alt="suggestion icon" />
                                    Bid ${listing.price_per_point - price} below the asking price, anticipating that the seller will make a counteroffer that falls somewhere within
                                    the “realistic range”.
                                </p>
                            </div>
                            <div className={css.imgWrap}>
                                <img alt={listing?.resort.short_name} className={css.suggestionImg} width={120} src={img.url} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
